import {EventEmitter, Injectable} from '@angular/core';
import {IFdeMfaSmsResponse, IFdeMfaSmsSendRequest, IMFAItem, IMFAItemResult} from './interface';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class MfaService {
  requested: EventEmitter<IMFAItem> = new EventEmitter<IMFAItem>();
  processed: EventEmitter<IMFAItemResult> = new EventEmitter<IMFAItemResult>();

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Request to show a mfa form
   * @param data form to build + necessary data, to process after mfa done
   */
  request(data: IMFAItem) {
    this.requested.emit(data);
  }

  /**
   * Form was processed by user
   * @param result true if processed, false if closed
   * @param data mfa object from .request() method
   */
  done(result: boolean, data: IMFAItem) {
    this.processed.emit({result, ...data});
  }

  sendFdeMfaSms(data: IFdeMfaSmsSendRequest) {
    return this.http.post(environment.API_URL + '/sms/send/refresh', {
      ...data,
      financialDataProvider: 'FDE',
    });
  }

  getFdeMfaSmsResponse(clientUsername: string, bankAccountId: number) {
    return this.http.get<IFdeMfaSmsResponse>(
      `${environment.API_URL}/statements/FDE/getSmsResponse/${encodeURIComponent(clientUsername)}/${bankAccountId}`
    );
  }
}
